class LpContactForm extends HTMLElement {
  connectedCallback() {
    this.inputStep = this.querySelector('[data-step="input"]');
    this.confirmStep = this.querySelector('[data-step="confirm"]');
    if (!this.inputStep || !this.confirmStep) return;

    this.confirmBtn = this.querySelector('.lp-contact-form__confirm-btn');
    this.backBtn = this.querySelector('.lp-contact-form__back-btn');

    this.confirmBtn?.addEventListener('click', this.showConfirmStep.bind(this));
    this.backBtn?.addEventListener('click', this.showInputStep.bind(this));
  }

  showConfirmStep() {
    const fields = this.inputStep.querySelectorAll('[data-confirm-source]');
    let firstInvalid = null;

    fields.forEach((field) => {
      const key = field.dataset.confirmSource;
      const errorEl = this.inputStep.querySelector(`[data-error-for="${key}"]`);
      const valid = field.checkValidity();
      field.classList.toggle('lp-contact-form__input--error', !valid);
      if (errorEl) errorEl.hidden = valid;
      if (!valid && !firstInvalid) firstInvalid = field;
    });

    if (firstInvalid) {
      firstInvalid.focus();
      return;
    }

    fields.forEach((field) => {
      if (field.type === 'checkbox') return;
      const key = field.dataset.confirmSource;
      const target = this.confirmStep.querySelector(`[data-confirm="${key}"]`);
      if (target) target.textContent = field.value.trim() || '（未入力）';
    });

    this.inputStep.hidden = true;
    this.confirmStep.hidden = false;
    this.confirmStep.querySelector('.lp-contact-form__confirm-title')?.focus();
    this.confirmStep.scrollIntoView({ behavior: 'smooth', block: 'start' });
  }

  showInputStep() {
    this.confirmStep.hidden = true;
    this.inputStep.hidden = false;
  }
}

customElements.define('lp-contact-form', LpContactForm);
